import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'

const labels = nutrimaticLabels.mobileSimple

function TokenPickerNoResultsIllustration({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <circle cx="100" cy="74" r="58" stroke="currentColor" strokeOpacity="0.1" strokeWidth="2" strokeDasharray="7 7" />
      <circle cx="86" cy="62" r="30" stroke="currentColor" strokeOpacity="0.34" strokeWidth="3" />
      <path
        d="M108 82L134 108"
        stroke="currentColor"
        strokeOpacity="0.34"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="132" cy="44" r="13" stroke="currentColor" strokeOpacity="0.16" strokeWidth="2" strokeDasharray="5 5" />
      <circle cx="54" cy="92" r="11" stroke="currentColor" strokeOpacity="0.12" strokeWidth="2" strokeDasharray="5 5" />
      <circle cx="118" cy="98" r="9" stroke="currentColor" strokeOpacity="0.1" strokeWidth="2" strokeDasharray="4 4" />
      <path
        d="M74 62h24M86 50v24"
        stroke="currentColor"
        strokeOpacity="0.42"
        strokeWidth="2.75"
        strokeLinecap="round"
      />
    </svg>
  )
}

/** Estado vacío del picker: ilustración + mensaje cuando no hay coincidencias. */
export function TokenPickerNoResultsView({
  title = labels.pickerNoResultsTitle,
  description = labels.pickerNoResultsLead,
  onCancel,
  cancelLabel = labels.pickerClearSearch,
  variant = 'nutrimatic',
  className,
}: {
  title?: string
  description?: string
  onCancel?: () => void
  cancelLabel?: string
  variant?: 'nutrimatic' | 'compact' | 'sheet'
  className?: string
}) {
  if (variant === 'compact') {
    return (
      <div className={cn('flex flex-col items-center px-4 py-6 text-center', className)}>
        <TokenPickerNoResultsIllustration className="mb-4 h-24 w-32 text-muted-foreground/70" />
        <p className="text-sm font-semibold text-foreground">{title}</p>
        <p className="mt-1 max-w-xs text-xs leading-relaxed text-muted-foreground">{description}</p>
        {onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="mt-4 rounded-md border border-border px-3 py-2 text-xs font-medium text-muted-foreground hover:bg-muted/40"
          >
            {cancelLabel}
          </button>
        ) : null}
      </div>
    )
  }

  if (variant === 'sheet') {
    return (
      <div className={cn('flex flex-col items-center px-6 py-10 text-center', className)}>
        <TokenPickerNoResultsIllustration className="mb-5 h-28 w-36 text-muted-foreground/70" />
        <p className="text-base font-semibold text-foreground">{title}</p>
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>
        {onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="mt-5 rounded-lg border border-border px-4 py-2 text-sm font-medium text-muted-foreground hover:bg-muted/40"
          >
            {cancelLabel}
          </button>
        ) : null}
      </div>
    )
  }

  return (
    <div className={cn('nm-mobile-simple__picker-no-results', className)}>
      <TokenPickerNoResultsIllustration className="nm-mobile-simple__picker-no-results-art" />
      <p className="nm-mobile-simple__picker-no-results-title">{title}</p>
      <p className="nm-mobile-simple__picker-no-results-lead">{description}</p>
      {onCancel ? (
        <button type="button" className="nm-mobile-simple__picker-discovery-cancel" onClick={onCancel}>
          {cancelLabel}
        </button>
      ) : null}
    </div>
  )
}
